import { formatearFechaLuxon } from "../../utils/formatearFecha"
import Liquidacion from "../domain/Liquidacion"
import Comprobante from "../domain/Comprobante"
import Retencion from "../domain/Retencion"
import ApiServiceAdapter from "../infraestructure/ApiServiceAdapter"
import { obtenerValorEstado } from "./EstadoLiquidacionAdapter"
import { obtenerValorEtapa } from "./EtapaLiquidacionAdapter"
import Factura from "../domain/Factura"
import { obtenerValorEstadoFactura } from "./EstadoFacturaHLAdapter"

class LiquidacionService {
  constructor() {
    this.apiService = new ApiServiceAdapter()
  }

  async getListLiquidaciones(cuit, nroSiniestro, caratula, expediente, idJuicio) {
    let listadoLiquidaciones

    try {
      const liquidacionesData = await this.apiService.fetchLiquidaciones(cuit, nroSiniestro, caratula, expediente, idJuicio)

      listadoLiquidaciones = !liquidacionesData ? [] : liquidacionesData.map(
        (liq) =>
          new Liquidacion(
            liq.idLiquidacion,
            liq.nroFactura,
            liq.nroRecibo,
            formatearFechaLuxon(liq.fechaEntrada, 'dd/MM/yyyy'),
            formatearFechaLuxon(liq.fechaVencimiento, 'dd/MM/yyyy'),
            liq.procesoJudicial,
            liq.trabajador,
            liq.prestador,
            obtenerValorEstado(liq.estado),
            liq.importe.toLocaleString('es-ES'),
            liq.anioFiscal,
            liq.nroGestion,
            liq.cbuPiscys,
            liq.cbuPiscys && !isNaN(liq.cbuPiscys.trim()[0]),
            liq.expediente,
            liq.idJuicio,
            liq.conceptoLetrado
          ))
    } catch (err) {
      listadoLiquidaciones = []
    }

    return listadoLiquidaciones
  }


  async obtenerComprobante(idLiquidacion,nroGestion, tieneFactura) {
    let comprobantes=[]
    try{

    const comprobanteData = await this.apiService.fetchObtenerComprobante(idLiquidacion,nroGestion, tieneFactura)

    comprobantes = comprobanteData &&
      new Comprobante(
        comprobanteData.idLiquidacionComprobanteTransferencia,
        comprobanteData.pyid,
        comprobanteData.nroFactura,
        comprobanteData.nroDocumento,
        comprobanteData.banco,
        comprobanteData.cbu,
        comprobanteData.fechaInterbanking,
        comprobanteData.nroTransferencia,
        comprobanteData.nroRed,
        comprobanteData.monto.toLocaleString('es-ES'),
        comprobanteData.ctaBancaria,
        comprobanteData.fechaIntegracion,
        comprobanteData.bancoDebito,
        comprobanteData.cbuDebito,
        comprobanteData.caratulaJuicio
      )
    }
    catch(e){
      comprobantes=undefined
    }
    return comprobantes
  }


  async getListReteciones(idLiquidacion,nroGestion) {
    const retencionesData = await this.apiService.fetchObtenerRetenciones(idLiquidacion,nroGestion)

    const listadoRetenciones = !retencionesData ? [] : retencionesData.map(
      (liq) =>
        new Retencion(
          liq.idLiquidacionDetalleRetencion,
          liq.pyid,
          liq.nroFactura,
          liq.nroDocumento,
          formatearFechaLuxon(liq.fechaComprobante, 'dd/MM/yyyy'),
          liq.alicuota,
          liq.nroOrden,
          liq.cuit,
          formatearFechaLuxon(liq.fechaPago, 'dd/MM/yyyy'),
          liq.montoFactura < 0 ? (-1 * liq.montoFactura).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : (liq.montoFactura).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          liq.montoPorLinea < 0 ? (-1 * liq.montoPorLinea).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : (liq.montoPorLinea).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          liq.montoPorLineaRetencion < 0 ? (-1 * liq.montoPorLineaRetencion).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : liq.montoPorLineaRetencion.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          liq.montoRetencionIIBB.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          liq.sujetoRetenido,
          liq.tipoRetencion
        )

    )

    return listadoRetenciones
  }

  //Esta seccion es para Facturas de las Liquidaciones

  async getListaFacturas(idLiquidacion, fechaFacturaInicio, fechaFacturaFin, fechaAltaInicio, fechaAltaFin,
    nroFactura, idJuicio, idAnalista, monImporteFacDesde, monImporteFacHasta, cuitLetrado, idPrestador,
    idTipoFactura, etapaFacturacion, idEstadoFactura) {

    let listadoFacturas
    try {
      const idLiquidacionWeb = (idLiquidacion == -2 || idLiquidacion == -1) ? undefined : idLiquidacion
      const cuitLetradoFormateado = cuitLetrado === undefined ? "" : cuitLetrado
      const intidPrestador = (idPrestador == -2 || idPrestador == -1) ? undefined : idPrestador
      const nrofactura = nroFactura === undefined ? "" : nroFactura
      const fechaFacturaInicioformateada = fechaFacturaInicio ? formatearFechaLuxon(fechaFacturaInicio, 'yyyy-MM-dd') : ""
      const fechaFacturaFinformateada = fechaFacturaFin ? formatearFechaLuxon(fechaFacturaFin, 'yyyy-MM-dd') : ""
      const fechaAltaInicioformateada = fechaAltaInicio ? formatearFechaLuxon(fechaAltaInicio, 'yyyy-MM-dd') : ""
      const fechaAltaFinformateada = fechaAltaFin ? formatearFechaLuxon(fechaAltaFin, 'yyyy-MM-dd') : ""
      const tipoFactura = (idTipoFactura == -2 || idTipoFactura == -1) ? undefined : idTipoFactura
      const idestadoFactura = (idEstadoFactura == -2 || idEstadoFactura == -1) ? undefined : idEstadoFactura
      const idJuicioFormateado = (idJuicio == -2 || idJuicio == -1) ? undefined : idJuicio

      const facturasData = await this.apiService.fetchFacturasLiquidaciones(idLiquidacionWeb, cuitLetradoFormateado, intidPrestador, idJuicioFormateado, fechaFacturaInicioformateada, fechaFacturaFinformateada, fechaAltaInicioformateada, fechaAltaFinformateada, nrofactura, idestadoFactura, monImporteFacDesde, monImporteFacHasta, idAnalista, tipoFactura, etapaFacturacion, '')

      listadoFacturas = facturasData && facturasData.map(
        (factura) =>
          new Factura(
            factura.intIdLiquidacionWeb,
            formatearFechaLuxon(factura.fechaFac, "dd/MM/yyyy"),
            formatearFechaLuxon(factura.fechaFac, "yyyy-MM-dd"),
            factura.idTipoFactura,
            factura.cuitPrestador,
            factura.cuitLetrado,
            factura.nombreLetrado,
            factura.idUsuarioExterno,
            factura.nroFactura,
            factura.importe,
            factura.idEstadoLiquidacionWeb,
            formatearFechaLuxon(factura.fechaAlta, 'dd/MM/yyyy'),
            formatearFechaLuxon(factura.fechaAlta, 'dd/MM/yyyy'),
            obtenerValorEstadoFactura(factura.estado),
            factura.tipoFactura,
            factura.caratulaJuicio,
            factura.detalleEstado,
            factura.etapaFacturacion,
            obtenerValorEtapa(factura.etapaFacturacion),
            factura.idLetradoCiaPrestador,
            factura.razonSocialPrestador,
            factura.idJuicio,
            factura.motivoRechazo,
            formatearFechaLuxon(factura.fechaAproboRechazo,'dd/MM/yyyy')
          )
      )

    } catch (err) {
      listadoFacturas = []
    }
    return listadoFacturas
  }

  async validarFactura(nroFactura, cuit) {

    let existeFactura = false
    const cantidad = await this.apiService.validarFactura(nroFactura, cuit)
    existeFactura = cantidad[0].cantidad > 0
    return existeFactura
  }
  async guardarFactura(factura, archivos) {
    let resultadoInsert

    try {

      const formData = new FormData();

      const data = {
        "chrNroFactura": factura.nroFactura,
        "datFechaFac": factura.fechaFactura,
        "intIdTipoFactura": factura.idTipoComprobante,
        "intIdLetradoCiaPrestador": factura.idLetradoCiaPrestador,
        "intIdJuicio": factura.idJuicio,
        "monImporteFac": factura.importe,
        "chrEtapaFacturacion": factura.etapaFacturacion,
        "intIdusuarioExterno": factura.idusuarioExterno,
        "documentos": factura.documentos
      }

      archivos && archivos.forEach((file, index) => {
        formData.append(`archivos`, file);
      });

      formData.append('data', JSON.stringify(data));

      //Inspeccionar FormData
      // for (let pair of formData.entries()) {
      //   console.log(pair[0], pair[1]);
      // }
      // console.log(data);
      // console.log(archivos)

      resultadoInsert = await this.apiService.guardarFactura(formData)

    }
    catch (err) {
      console.log(err)
    }
    //return "rdo"
    return resultadoInsert

  }


  async obtenerFacturaLiquidacion(idLiquidacion, cuit) {

    const facturasData = await this.apiService.fetchFacturasLiquidaciones(idLiquidacion, cuit, '', '', '', '', '', '', '', '', '', '', '', '', '', '')

    const factura = facturasData && new Factura(
      facturasData[0].intIdLiquidacionWeb,
      formatearFechaLuxon(facturasData[0].fechaFac, "dd/MM/yyyy"),
      formatearFechaLuxon(facturasData[0].fechaFac, "yyyy-MM-dd"),
      facturasData[0].idTipoFactura,
      facturasData[0].cuitPrestador,
      facturasData[0].cuitLetrado,
      facturasData[0].nombreLetrado,
      facturasData[0].idUsuarioExterno,
      facturasData[0].nroFactura,
      facturasData[0].importe,
      facturasData[0].idEstadoLiquidacionWeb,
      formatearFechaLuxon(facturasData[0].fechaAlta, 'dd/MM/yyyy'),
      formatearFechaLuxon(facturasData[0].fechaAlta, 'dd/MM/yyyy'),
      obtenerValorEstadoFactura(facturasData[0].estado),
      facturasData[0].tipoFactura,
      facturasData[0].caratulaJuicio,
      facturasData[0].detalleEstado,
      facturasData[0].etapaFacturacion,
      obtenerValorEtapa(facturasData[0].etapaFacturacion),
      facturasData[0].idLetradoCiaPrestador,
      facturasData[0].razonSocialPrestador,
      facturasData[0].idJuicio,
      facturasData[0].motivoRechazo,
      formatearFechaLuxon(facturasData[0].fechaAproboRechazo,'dd/MM/yyyy')
    )
    return factura
  }
}

export default LiquidacionService
